import { handleResponseError, renameUploadFileName } from 'helpers/utils'
import { API } from './endpoint'
import httpClient from '../axios/interceptors'
import { AxiosResponse } from 'axios'
import { AddSelectTransportationInput, AddSelectTransportationResponse, CreateAgentInput, CreateAgentResponse, CreateBankInput, CreateBankResponse, CreateGeographyInput, CreateTransportationAgentInput, CreateTransportationAgentResponse, CreateTransportationInput, CreateTransportationResponse, CreatePayoutInput, CreatePayoutResponse, DeleteBankInput, DeleteSelectTransportationInput, DeleteSelectTransportationResponse, DeleteTransportationAgentInput, DeleteTransportationAgentResponse, DeleteTransportationInput, DeleteTransportationResponse, GetAgentBankListResponse, GetAgentBankTypeListResponse, GetAgentByIdResponse, GetAgentListByTelephoneResponse, GetBankAllListInput, GetBankAllListResponse, GetFactoryByAdminInput, GetFactoryByAdminResponse, GetFactoryByIdResponse, GetLogoBankResponse, GetOrderBangbowByFactoryInput, GetOrderBangbowByFactoryResponse, GetOrderInProgressInput, GetOrderInProgressResponse, GetOrderInProgressSummaryInput, GetOrderInProgressSummaryResponse, GetOrderItemCompleteInput, GetOrderItemCompleteResponse, GetOrderPendingPaymentSummaryInput, GetOrderPendingPaymentSummaryResponse, GetPayoutPendingSummaryResponse, PayoutBatchSummaryResponse, PayoutDetailResponse, PayoutListInput, PayoutListResponse, LoadBankListInput, LoadBankListResponse, LoadTransportationIDInput, LoadTransportationResponse, TransportTypeSelectResponse, TransportationConfigsByAgentIdResponse, TransportationTypeResponse, UpdateAgentInput, UpdateBankStatusInput, UpdateTransportationInput, UpdateTransportationResponse, createAgentBankInput, createAgentBankResponse, createAgentBankTypeInput, createAgentBankTypeResponse, createRetailBankTypeInput, createRetailBankTypeResponse, deleteAgentBankInput, deleteAgentBankResponse, deleteAgentBankTypeInput, deleteAgentBankTypeResponse, deleteAgentImmediatelyInput, deleteAgentImmediatelyResponse, loadTransportationAllInput, loadTransportationAllResponse } from './interface'

export const createAgentByFactory = async (
  input: CreateAgentInput
): Promise<CreateAgentResponse> => {
  const data: AxiosResponse<CreateAgentResponse> = await httpClient
    .post(API.createAgentByFactory, input)
    .catch((error) => handleResponseError(error))
  return data.data
}


export const createRetailByFactory = async (
  input: CreateAgentInput
): Promise<CreateAgentResponse> => {
  const data: AxiosResponse<CreateAgentResponse> = await httpClient
    .post(API.createRetailByFactory, input)
    .catch((error) => handleResponseError(error))
  return data.data
}


export const UpdateAgentByFactory = async (
  input: UpdateAgentInput
): Promise<CreateAgentResponse> => {
  const data: AxiosResponse<CreateAgentResponse> = await httpClient
    .post(API.updateAgentByFactory, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const UpdateRetailByFactory = async (
  input: UpdateAgentInput
): Promise<CreateAgentResponse> => {
  const data: AxiosResponse<CreateAgentResponse> = await httpClient
    .post(API.updateRetailByFactory, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const deleteUserImmediately = async (
  input: deleteAgentImmediatelyInput
): Promise<deleteAgentImmediatelyResponse> => {
  const data: AxiosResponse<deleteAgentImmediatelyResponse> = await httpClient
    .post(API.deleteUserImmediately, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getAgentListByTelephone = async (
  telephone: string
): Promise<GetAgentListByTelephoneResponse> => {
  const data: AxiosResponse<GetAgentListByTelephoneResponse> = await httpClient
    .get(API.findAgentByTelephone + telephone)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getAgentByTelephone = async (
  telephone: string
): Promise<GetAgentByIdResponse> => {
  const data: AxiosResponse<GetAgentByIdResponse> = await httpClient
    .get(API.getAgentByTelephone + telephone)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getBankAdminList = async (input: GetBankAllListInput): Promise<GetBankAllListResponse> => {
  const data: AxiosResponse<GetBankAllListResponse> = await httpClient
    .post(API.getBankAdminList, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getBankActiveList = async (factoryId: string): Promise<GetBankAllListResponse> => {
  const data: AxiosResponse<GetBankAllListResponse> = await httpClient
    .get(API.getBankActiveList + factoryId)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getBankInActiveList = async (factoryId: string): Promise<GetBankAllListResponse> => {
  const data: AxiosResponse<GetBankAllListResponse> = await httpClient
    .get(API.getBankInActiveList + factoryId)
    .catch((error) => handleResponseError(error))
  return data.data
}

// export const getBankById = async (factoryId: string): Promise<GetBankAllListResponse> => {
//   const data: AxiosResponse<GetBankAllListResponse> = await httpClient
//     .get(API.getBankInactiveList + factoryId)
//     .catch((error) => handleResponseError(error))
//   return data.data
// }

export const getBankById = async (id: string): Promise<GetBankAllListResponse> => {
  const data: AxiosResponse<GetBankAllListResponse> = await httpClient
    .get(API.getBankById + id)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getLogoBank = async (): Promise<GetLogoBankResponse[]> => {
  const data: AxiosResponse<GetLogoBankResponse[]> = await httpClient
    .get(API.getLogoBank)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const createBankFactory = async (
  input: CreateBankInput
): Promise<CreateBankResponse> => {
  const data: AxiosResponse<CreateBankResponse> = await httpClient
    .post(API.createBank, input)
    .catch((error) => handleResponseError(error))
  return data.data
}


export const updateBankFactory = async (
  input: CreateBankInput
): Promise<CreateBankResponse> => {
  const data: AxiosResponse<CreateBankResponse> = await httpClient
    .post(API.updateBank, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const updateBankFactoryStatus = async (
  input: UpdateBankStatusInput
): Promise<CreateBankResponse> => {
  const data: AxiosResponse<CreateBankResponse> = await httpClient
    .post(API.updateBankStatus, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const deleteBankFactory = async (
  input: DeleteBankInput
): Promise<CreateBankResponse> => {
  const data: AxiosResponse<CreateBankResponse> = await httpClient
    .post(API.deleteBank, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const loadTransportationAll = async (
  input: loadTransportationAllInput
): Promise<loadTransportationAllResponse> => {
  const data: AxiosResponse<loadTransportationAllResponse> = await httpClient
    .post(API.loadTransportationConfigsAll, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getTransportationType = async (): Promise<TransportationTypeResponse> => {
  const data: AxiosResponse<TransportationTypeResponse> = await httpClient
    .get(API.getTransportationType)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getTransportationConfigs = async (input: LoadTransportationIDInput): Promise<LoadTransportationResponse> => {
  const data: AxiosResponse<LoadTransportationResponse> = await httpClient
    .post(API.getTransportationConfigs, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const createTransportationConfigs = async (
  input: CreateGeographyInput
): Promise<CreateTransportationResponse> => {
  const data: AxiosResponse<CreateTransportationResponse> = await httpClient
    .post(API.createTransportationConfigs, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const updateTransportationConfigs = async (
  input: UpdateTransportationInput
): Promise<UpdateTransportationResponse> => {
  const data: AxiosResponse<UpdateTransportationResponse> = await httpClient
    .post(API.updateTransportationConfigs, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const deleteTransportationConfigs = async (
  input: DeleteTransportationInput
): Promise<DeleteTransportationResponse> => {
  const data: AxiosResponse<DeleteTransportationResponse> = await httpClient
    .post(API.deleteTransportationConfigs, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getTransportationConfigsByAgentId = async (
  input: string): Promise<TransportationConfigsByAgentIdResponse> => {
  const data: AxiosResponse<TransportationConfigsByAgentIdResponse> = await httpClient
    .get(API.getTransportationConfigsByAgentId + input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const createTransportationAgent = async (
  input: CreateTransportationAgentInput
): Promise<CreateTransportationAgentResponse> => {
  const data: AxiosResponse<CreateTransportationAgentResponse> = await httpClient
    .post(API.createTransportationAgent, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const deleteTransportationAgent = async (
  input: DeleteTransportationAgentInput
): Promise<DeleteTransportationAgentResponse> => {
  const data: AxiosResponse<DeleteTransportationAgentResponse> = await httpClient
    .post(API.deleteTransportationAgent, input)
    .catch((error) => handleResponseError(error))
  return data.data
}


export const loadBankList = async (
  input: LoadBankListInput
): Promise<LoadBankListResponse> => {
  const data: AxiosResponse<LoadBankListResponse> = await httpClient
    .post(API.loadBankList, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getAgentBankList = async (input: string): Promise<GetAgentBankListResponse> => {
  const data: AxiosResponse<GetAgentBankListResponse> = await httpClient
    .get(API.getAgentBankList + input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const createAgentBank = async (
  input: createAgentBankInput
): Promise<createAgentBankResponse> => {
  const data: AxiosResponse<createAgentBankResponse> = await httpClient
    .post(API.createAgentBank, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const deleteAgentBank = async (
  input: deleteAgentBankInput
): Promise<deleteAgentBankResponse> => {
  const data: AxiosResponse<deleteAgentBankResponse> = await httpClient
    .post(API.deleteAgentBank, input)
    .catch((error) => handleResponseError(error))
  return data.data
}


export const getAgentBankTypeList = async (input: string): Promise<GetAgentBankTypeListResponse> => {
  const data: AxiosResponse<GetAgentBankTypeListResponse> = await httpClient
    .get(API.getAgentBankTypeList + input)
    .catch((error) => handleResponseError(error))
  return data.data
}


export const getRetailBankTypeList = async (input: string): Promise<GetAgentBankTypeListResponse> => {
  const data: AxiosResponse<GetAgentBankTypeListResponse> = await httpClient
    .get(API.getRetailBankTypeList + input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const createAgentBankType = async (
  input: createAgentBankTypeInput
): Promise<createAgentBankResponse> => {
  const data: AxiosResponse<createAgentBankTypeResponse> = await httpClient
    .post(API.createAgentBankType, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const deleteAgentBankType = async (
  input: deleteAgentBankTypeInput
): Promise<deleteAgentBankTypeResponse> => {
  const data: AxiosResponse<deleteAgentBankTypeResponse> = await httpClient
    .post(API.deleteAgentBankType, input)
    .catch((error) => handleResponseError(error))
  return data.data
}


export const createRetailBankType = async (
  input: createRetailBankTypeInput
): Promise<createRetailBankTypeResponse> => {
  const data: AxiosResponse<createRetailBankTypeResponse> = await httpClient
    .post(API.createRetailBankType, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const deleteRetailBankType = async (
  input: createRetailBankTypeInput
): Promise<createRetailBankTypeResponse> => {
  const data: AxiosResponse<createRetailBankTypeResponse> = await httpClient
    .post(API.deleteRetailBankType, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

///transportation/config/factory_transport_type/{factory_id}
export const getTransportationTypeByFactory = async (factoryId: string): Promise<TransportTypeSelectResponse> => {
  const data: AxiosResponse<TransportTypeSelectResponse> = await httpClient
    .get(API.getTransportationTypeByFactory + factoryId)
    .catch
    ((error) => handleResponseError(error))
  return data.data
}

///transportation/config/add_factory_transport
export const addTransportationTypeByFactory = async (input: AddSelectTransportationInput): Promise<AddSelectTransportationResponse> => {
  const data: AxiosResponse<AddSelectTransportationResponse> = await httpClient
    .post(API.addTransportationTypeByFactory, input)
    .catch
    ((error) => handleResponseError(error))
  return data.data
}

///transportation/config/delete_factory_transport
export const deleteTransportationTypeByFactory = async (input: DeleteSelectTransportationInput): Promise<DeleteSelectTransportationResponse> => {
  const data: AxiosResponse<DeleteSelectTransportationResponse> = await httpClient
    .post(API.deleteTransportationTypeByFactory, input)
    .catch
    ((error) => handleResponseError(error))
  return data.data
}

//factory/report/order_by_factory
export const getOrderBangbowByFactory = async (input: GetOrderBangbowByFactoryInput): Promise<GetOrderBangbowByFactoryResponse> => {
  const data: AxiosResponse<GetOrderBangbowByFactoryResponse> = await httpClient
    .post(API.getOrderBangbowByFactory, input)
    .catch
    ((error) => handleResponseError(error))
  return data.data
}

//factory/report/order_in_progress
export const getOrderInProgress = async (input: GetOrderInProgressInput): Promise<GetOrderInProgressResponse> => {
  const data: AxiosResponse<GetOrderInProgressResponse> = await httpClient
    .post(API.getOrderInProgress, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

//factory/report/order_pending_payment
export const getOrderPendingPayment = async (input: GetOrderInProgressInput): Promise<GetOrderInProgressResponse> => {
  const data: AxiosResponse<GetOrderInProgressResponse> = await httpClient
    .post(API.getOrderPendingPayment, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

//factory/report/order_in_progress_summary
export const getOrderInProgressSummary = async (input: GetOrderInProgressSummaryInput): Promise<GetOrderInProgressSummaryResponse> => {
  const data: AxiosResponse<GetOrderInProgressSummaryResponse> = await httpClient
    .post(API.getOrderInProgressSummary, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

//factory/report/order_pending_payment_summary
export const getOrderPendingPaymentSummary = async (input: GetOrderPendingPaymentSummaryInput): Promise<GetOrderPendingPaymentSummaryResponse> => {
  const data: AxiosResponse<GetOrderPendingPaymentSummaryResponse> = await httpClient
    .post(API.getOrderPendingPaymentSummary, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

// factory/report/order_item_complete
export const getOrderItemCompleteReport = async (
  input: GetOrderItemCompleteInput
): Promise<GetOrderItemCompleteResponse> => {
  const data: AxiosResponse<GetOrderItemCompleteResponse> = await httpClient
    .post(API.getOrderItemCompleteReport, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

// factory/report/payout/pending-summary
export const getPayoutPendingSummary = async (): Promise<GetPayoutPendingSummaryResponse> => {
  const data: AxiosResponse<GetPayoutPendingSummaryResponse> = await httpClient
    .get(API.payoutPendingSummary)
    .catch((error) => handleResponseError(error))
  return data.data
}

// factory/report/payout/create
export const createPayout = async (input: CreatePayoutInput): Promise<CreatePayoutResponse> => {
  const data: AxiosResponse<CreatePayoutResponse> = await httpClient
    .post(API.payoutCreate, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

// factory/report/payout/batch-summary
export const getPayoutBatchSummary = async (): Promise<PayoutBatchSummaryResponse> => {
  const data: AxiosResponse<PayoutBatchSummaryResponse> = await httpClient
    .get(API.payoutBatchSummary)
    .catch((error) => handleResponseError(error))
  return data.data
}

// factory/report/payout/list
export const listPayout = async (input: PayoutListInput): Promise<PayoutListResponse> => {
  const data: AxiosResponse<PayoutListResponse> = await httpClient
    .post(API.payoutList, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

// GET /factory/report/payout/:id/items
export const getPayoutItems = async (id: string): Promise<PayoutDetailResponse> => {
  const data: AxiosResponse<PayoutDetailResponse> = await httpClient
    .get(`${API.payoutItems}/${id}/items`)
    .catch((error) => handleResponseError(error))
  return data.data
}

// Export payout items to Excel
export const exportPayoutItems = async (id: string): Promise<void> => {
  const detail = await getPayoutItems(id)
  const data = detail.data
  await exportPayoutDetailToExcel(data)
}

const PAYMENT_TYPE_LABEL: Record<string, string> = {
  bank_transfer: 'โอนเงินผ่านธนาคาร',
  cash: 'เงินสด',
  cheque: 'เช็ค',
}

export const exportPayoutDetailToExcel = async (data: {
  payout_code: string
  total_amount: number
  payout_status: string
  create_date: string
  paid_at?: string | null
  payment_type?: string | null
  receipt_url?: string | null
  bank_name?: string | null
  recipient_account?: string | null
  receiver_name?: string | null
  note?: string | null
  items: import('./interface').PayoutItem[]
}): Promise<void> => {
  const XLSX = await import('xlsx')
  const fileSaver = await import('file-saver')
  const saveAs = fileSaver.saveAs ?? (fileSaver as any).default?.saveAs ?? (fileSaver as any).default
  const { formatDateAndTime } = await import('utils/convertData')

  const statusLabel =
    data.payout_status === 'pending'
      ? 'รอโอน'
      : data.payout_status === 'paid' && !data.receipt_url
      ? 'โอนแล้วรอใบเสร็จ'
      : 'เสร็จสิ้น'

  const paymentTypeLabel = data.payment_type ? (PAYMENT_TYPE_LABEL[data.payment_type] ?? data.payment_type) : '-'
  const formatDate = (d?: string | null) => (d ? formatDateAndTime(d) : '-')

  const infoRows = [
    ['หมายเลขรายการ', data.payout_code, '', 'วันที่ทำรายการ', formatDate(data.create_date)],
    ['สถานะ', statusLabel, '', 'วันที่โอนเงิน', formatDate(data.paid_at)],
    ['ประเภทการชำระ', paymentTypeLabel, '', 'ยอดรวม (บาท)', data.total_amount],
    ['ธนาคาร', data.bank_name ?? '-', '', 'เลขบัญชี', data.recipient_account ?? '-'],
    ['ชื่อบัญชี', data.receiver_name ?? '-', '', 'หมายเหตุ', data.note ?? '-'],
    ['จำนวนรายการ', data.items.length, '', '', ''],
    [],
  ]

  const headers = [
    'หมายเลขคำสั่งซื้อ',
    'ชื่อสินค้า',
    'ตัวเลือกสินค้า',
    'จำนวน',
    'ราคารวมที่โอนให้ผู้ประกอบการรวม vat (บาท)',
  ]

  const itemRows = data.items.map((item) => [
    item.order_code,
    item.product_name,
    item.sku_description,
    item.item_qty,
    item.total_amount,
  ])

  const ws = XLSX.utils.aoa_to_sheet([...infoRows, headers, ...itemRows])

  ws['!cols'] = [
    { wch: 22 },
    { wch: 30 },
    { wch: 6 },
    { wch: 18 },
    { wch: 30 },
  ]

  const wb = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(wb, ws, 'รายการโอนเงิน')

  const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
  const blob = new Blob([excelBuffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })
  saveAs(blob, `${data.payout_code}.xlsx`)
}

// POST /files/upload
export const uploadFile = async (file: File): Promise<{ url: string; id: string }> => {
  const formData = new FormData()
  const safeFileName = renameUploadFileName(file.name)
  formData.append('file', file, safeFileName)
  const data: AxiosResponse<{ url: string; id: string }> = await httpClient
    .post(API.uploadFile, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
    .catch((error) => handleResponseError(error))
  return data.data
}

/** อัปโหลดรูปเข้า master_image (เสิร์ฟที่ /images/:id) — ใช้กับรูปที่เกี่ยวกับสต็อก */
export const uploadImage = async (
  file: File,
  type = 'product'
): Promise<{ url: string; id: string }> => {
  const formData = new FormData()
  const safeFileName = renameUploadFileName(file.name)
  formData.append('file', file, safeFileName)
  const data: AxiosResponse<{ url: string; id: string }> = await httpClient
    .post(`${API.uploadImage}?type=${type}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .catch((error) => handleResponseError(error))
  return data.data
}

// PATCH /factory/report/payout/:id/receipt
export const updatePayoutReceipt = async (id: string, receiptUrl: string): Promise<void> => {
  await httpClient
    .patch(`${API.payoutItems}/${id}/receipt`, { receipt_url: receiptUrl })
    .catch((error) => handleResponseError(error))
}

// PATCH /factory/report/payout/:id/file-list
export const updatePayoutFileList = async (id: string, fileList: string[]): Promise<void> => {
  await httpClient
    .patch(`${API.payoutItems}/${id}/file-list`, { file_list: fileList })
    .catch((error) => handleResponseError(error))
}

//factory/admin/factory_by_admin
export const getFactoryByAdmin = async (input: GetFactoryByAdminInput): Promise<GetFactoryByAdminResponse> => {
  const data: AxiosResponse<GetFactoryByAdminResponse> = await httpClient
    .post(API.getFactoryByAdmin, input)
    .catch
    ((error) => handleResponseError(error))
  return data.data
}

export const getFactoryById = async (id: string, includeProduct: number = 0): Promise<GetFactoryByIdResponse> => {
  const data: AxiosResponse<GetFactoryByIdResponse> = await httpClient
    .get(`${API.getFactoryById}${id}?include_product=${includeProduct}`)
    .catch((error) => handleResponseError(error))
  return data.data
}
